import {
  UpdateIconButton,
  formatDate,
  pn,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CrudMode,
  formatFileSize,
  Button,
  Stack,
  Typography,
  RichTextReader,
} from "@compass/core";
import { ListBeProperty } from "components";
import {
  Permission,
  PermissionAction,
  SortObject,
  StudentApplicationListDto,
  StudentApplicationListResource,
  StudentFileListDto,
} from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import PreviewIcon from "@mui/icons-material/Preview";
import ApiService from "services/apiService";
// import { studentFilePageRoute } from "../StudentApplicationPage/StudentApplicationPage";

export const StudentFileTable = (props: {
  openNewTab: boolean;
  rootPermission: Permission;
  tableContainerRef: React.RefObject<HTMLDivElement>;
  studentFiles: StudentFileListDto[];
  listTotal: number | undefined;
  resource: StudentApplicationListResource;
  searchFocused: boolean;
  sortObjects: SortObject[] | undefined;
  sort: (sortObjects: SortObject[]) => void;
  selectId: (id: number) => void;
  selectedIds: number[];
  setSelectedIds: React.Dispatch<React.SetStateAction<number[]>>;
  getIdsPromise: () => Promise<any>;
}) => {
  const navigate = useNavigate();
  const properties = props.resource.properties || [];

  const getFile = async (file : StudentFileListDto) => {
    const open = true;
    if (file.uploadFile?.fileRef && file.uploadFile.fileName) {
      const fileRef = file.uploadFile.fileRef;
      const fileName = file.uploadFile.fileName;

      ApiService.common.getFile(fileRef, fileName).then((response) => {
        const blob = response!.data;
        const url = window.URL.createObjectURL(blob);

        if (open) {
          window.open(url, "_blank");
        } else {
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
    }
  };

  return (
    <TableContainer ref={props.tableContainerRef}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StudentFileListDto>("fileCategory"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>

            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StudentFileListDto>("fileName"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>

            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StudentFileListDto>("note"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StudentFileListDto>("fileSize"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StudentFileListDto>("createdDate"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>

            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.studentFiles.map((studentFileItem) => (
            <TableRow
              key={studentFileItem.id}
            // onClick={() => navigateApplicationResponseView(studentApplicationItem, "view")}
            >

              <TableCell>{studentFileItem.fileCategory}</TableCell>
              <TableCell>{studentFileItem.fileName}</TableCell>
              <TableCell><RichTextReader html={studentFileItem.note}/></TableCell>
              <TableCell>{formatFileSize(studentFileItem.fileSize)}</TableCell>
              <TableCell>{formatDate(studentFileItem.createdDate)}</TableCell>
              <TableCell type="action">
                <Button
                  onClick={() => { getFile(studentFileItem) }}
                >
                  <Stack direction="row">
                    <PreviewIcon />
                    <Typography variant="inherit" sx={{ paddingLeft: "10px" }}>
                      View
                    </Typography>
                  </Stack>
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
